import { userSlice } from 'store/user/slice';

export const Actions = {
  ...userSlice.actions,
};
